import { initializeAnimations } from './animation-module';
initializeAnimations();
import { initializeIconAnimations } from './icon-animations';
initializeIconAnimations();